module.exports = __webpack_public_path__ + "img/bj.34da3b21.png";